// eslint-disable-next-line import/prefer-default-export
export const TREE_TYPES = {
  customer: 'customer',
  user: 'user',
  division: 'division',
};
